<template>
  <div class="mainBanner">
    <el-row>
      <el-col :md="24" :lg="24" :xl="24">
        <div class="center">
          <div class="banner-overlay1">
            <span class="title">机器学习的算力优化和模型运维</span>
            <div class="try-btn-area">
              <router-link to="/contact-us-new">
                <div class="btn-contactUs">联系我们</div>
              </router-link>
            </div>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
  export default {
    name: 'MainBanner',
  }
</script>

<style>
  @media(min-width:992px) {
    .mainBanner {
      width: 100%;
      height: 38.49vw;
      background-image: url("../assets/images/newbanner.png");
      overflow-y: hidden;
      margin-top: 72px;
      background-repeat: no-repeat;
      background-size: 100% 100%;
    }

    .mainBanner .center {
      width: auto !important;
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      padding-left: 13.54vw;
    }

    .mainBanner .banner-overlay1 {
      padding-top: 11.3vw;
      color: #FFFFFF;
      text-align: left;
    }

    .mainBanner .banner-overlay1 .title {
      font-size: 56px;
      font-weight: 500;
      color: #FFFFFF;
      line-height: 63px;
      display: inline;
    }

    .mainBanner .banner-overlay1 h1 {
      color: #FFFFFF;
      font-size: 30px;
      transform: translateY(0px);
      line-height: 64px;
      transition: all 0.6s;
      margin-bottom: 15px;
      width: 100%;
    }

    .mainBanner .banner-overlay1 p {
      color: #FFFFFF;
      font-size: 16px;
      transform: translateY(0px);
      line-height: 30px;
      transition: all 0.6s;
      width: 100%;
    }

    .mainBanner .banner-overlay1 .try-btn-area {
      color: #FFFFFF;
      width: initial;
      text-align: left;
      font-size: 48px;
      line-height: 48px;
    }
    .mainBanner .btn-contactUs {
      margin-top: 4.9vw;
      cursor: pointer;
      color: #fff;
      width: 168px;
      height: 58px;
      border-radius: 29px;
      background: linear-gradient(90deg, rgba(39, 46, 63, 0.38) 0%, rgba(33, 36, 51, 0.34) 100%), url('../assets/images/svg/btnborder.svg');
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 20px;
      font-weight: 400;
    }
  }
  @media(max-width:992px) {
    .mainBanner {
      width: 100vw;
      height: 38.5vw;
      background-image: url("../assets/images/newbanner.png");
      overflow-y: hidden;
      margin-top: 8vw !important;
      background-repeat: no-repeat;
      background-size: 100% 100%;
    }
    .mainBanner .center {
      width: auto !important;
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      padding-left: 8vw;
    }

    .mainBanner .banner-overlay1 {
      padding-top: 16vw;
      color: #FFFFFF;
      text-align: left;
    }

    .mainBanner .banner-overlay1 .title {
      font-size: 12px;
      font-weight: 400;
      color: #FFFFFF;
      line-height: 16px;
      display: inline;
    }

    .mainBanner .banner-overlay1 .try-btn-area {
      color: #FFFFFF;
      text-align: left;
      display: none;
    }
    .mainBanner .btn-contactUs {
      width: 24vw;
      margin-top: 4vw;
      cursor: pointer;
      color: #fff;
      border: 1px solid #ffffff;
      border-radius: 12px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 12px;
      font-weight: 300;
      padding: 2vw;
    }
  }
</style>
<style></style>


// WEBPACK FOOTER //
// src/components/MainBanner.vue